import { Col, Form, Input, message, PageHeader, Row, Select } from "antd";
import { getLoggedUser } from "explorer/reducers/users";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { MaskInput } from "shared/components";
import { IsValidBrazilianPhone } from "shared/helpers/phone-helpers";
import { saveLoggedUser } from "shared/service/StrmService";

const DetalhesConta: React.FC<any> = () => {
  const [habilitaEdicao, setHabilitaEdicao] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const loggedUser = useSelector((state: any) => state.users.loggedUser);
  const { countryOptions } = useSelector((state: any) => state.countries);
  const dispatch = useDispatch();

  const onFinish = async () => {
    await form.validateFields();
    setLoading(true);
    const { mercadoPagoTransactions, userTeam, ...rest }: any =
      form.getFieldsValue(true);
    try {
      await saveLoggedUser(rest);
      dispatch(getLoggedUser());
      message.success(t("pages.MeusDados.sucesso"));
    } catch (error: any) {
      message.error(error.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [loggedUser, form]);

  return (
    <div>
      <PageHeader
        title={t("pages.MeusDados.titulo")}
        extra={[
          <button
            className="botao-vazado"
            onClick={() => setHabilitaEdicao(!habilitaEdicao)}
          >
            {t("pages.MeusDados.noFix")}
          </button>,
        ]}
      />

      <Form
        form={form}
        initialValues={loggedUser}
        onFinish={onFinish}
        style={{ color: "#fff" }}
      >
        <Row gutter={32}>
          <Col xs={6}>
            <span className="label">{t("pages.MeusDados.fullName")}</span>
          </Col>
          <Col xs={12}>
            <Form.Item name="name">
              <Input disabled={!habilitaEdicao} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={32}>
          <Col xs={6}>
            <span className="label">{t("pages.MeusDados.email")}</span>
          </Col>
          <Col xs={12}>
            <Form.Item name="login">
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={32}>
          <Col xs={6}>
            <span className="label">{t("pages.MeusDados.phone")}</span>
          </Col>
          <Col xs={12}>
            <Form.Item
              name="phone"
              rules={[
                ({ getFieldsValue }) => ({
                  validator(_, value) {
                    const formValues = getFieldsValue();
                    if (
                      formValues.countryCode === "BR" &&
                      formValues.phone.match(/\d/) &&
                      !IsValidBrazilianPhone(
                        formValues.phone.replace(/\D/g, "")
                      )
                    )
                      return Promise.reject(
                        new Error(t("pages.MeusDados.telefoneInvalido"))
                      );

                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <MaskInput mask="(99) 9999-99999" disabled={!habilitaEdicao} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={32}>
          <Col xs={6}>
            <span className="label">{t("pages.MeusDados.country")}</span>
          </Col>
          <Col xs={12}>
            <Form.Item name="countryCode">
              <Select
                disabled={!habilitaEdicao}
                options={countryOptions}
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={32}>
          <Col xs={6}>
            <span className="label">{t("pages.MeusDados.state")}</span>
          </Col>
          <Col xs={12}>
            <Form.Item name="state">
              <Input disabled={!habilitaEdicao} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={32}>
          <Col xs={6}>
            <span className="label">{t("pages.MeusDados.city")}</span>
          </Col>
          <Col xs={12}>
            <Form.Item name="city">
              <Input disabled={!habilitaEdicao} />
            </Form.Item>
          </Col>
        </Row>
        {habilitaEdicao && (
          <Row>
            <Col xs={12} offset={6}>
              <button
                className="botao-colorido"
                style={{ width: "100%" }}
                disabled={loading}
              >
                {t("pages.MeusDados.alterar")}
              </button>
            </Col>
          </Row>
        )}
      </Form>
    </div>
  );
};

export default DetalhesConta;
